import React from 'react';

import {
    BodyText,
    Button,
    Heading,
    Link,
    Modal,
    PinAlertIllustration,
} from '@placer-ui/components';
import { TitleModalHeader } from 'features/offline-reports/support-requests/components/support-requests-modals/components/title-modal-header/title-modal-header';
import styles from './support-failed-modal.module.scss';
import { useOpenSupportRequest } from '../../support-modal-manager';
import {
    SupportRequestsData,
    SupportRequestType,
} from 'features/offline-reports/support-requests/components/support-requests-modals/types';

export const SupportRequestsFailedModal = ({
    retryModalType,
    ...props
}: {
    retryModalType: SupportRequestType;
}) => {
    const { openSupportRequest, closeSupportRequest } = useOpenSupportRequest();

    const handleRetryClick = () => {
        if (retryModalType === 'suggestEdit') {
            return openSupportRequest({
                flowType: retryModalType,
                props: props as SupportRequestsData['suggestEdit'],
            });
        }

        openSupportRequest({ flowType: retryModalType ?? 'typeSelection' });
    };

    return (
        <>
            <TitleModalHeader title="Ticket Submission Failed" />
            <Modal.Content fullSize>
                <div className={styles.failedContent}>
                    <div className={styles.failedIcon}>
                        <PinAlertIllustration />
                    </div>
                    <Heading variant="h2">We Couldn’t Submit the Ticket</Heading>
                    <BodyText>
                        If the issue persists, contact support at{' '}
                        <Link href="mailto:support@placer.ai">support@placer.ai.</Link>
                    </BodyText>
                </div>
            </Modal.Content>
            <Modal.Footer>
                <Modal.Footer.RightControls>
                    <Button
                        testId="support-request-failed-modal-close"
                        variant="secondary-blue"
                        fullWidth
                        onClick={() => closeSupportRequest()}
                    >
                        Close
                    </Button>
                    <Button
                        testId="support-request-failed-modal-retry"
                        variant="primary-brand"
                        fullWidth
                        onClick={handleRetryClick}
                    >
                        Retry
                    </Button>
                </Modal.Footer.RightControls>
            </Modal.Footer>
        </>
    );
};
